/**
* Author: DanSmile
* Date: 2019/8/7
* Time: 18:53
*/
<template>
    <div class="box">
        <div class="sign-fail" v-if="errorMsg">
            <Icon type="ios-close-circle" size="60" color="#FA6A6A" class="icon"/>
            <p class="mesg">{{errorMsg}}</p>
            <Button type="primary" shape="circle" to="/">去首页</Button>
        </div>
        <swiper v-else :options="swiperOptionOut" ref="swiperOut">
            <swiper-slide>
                <div class="login">
                    <p class="title">{{info.name}}</p>
                    <p class="msg">感谢您能抽出几分钟时间来参加本次测评，现在我们就马上开始吧！</p>
                    <Input type="number" v-model="mobile" placeholder="请输入手机号" />
                    <Button type="primary" shape="circle" long  @click="check">下一步</Button>
                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="code-box" v-if="questions.length === 0">
                    <p class="title">请输入验证码</p>
                    <div class="ys-verification" v-if="send">
                        <div class="input-wrapper" v-for="item in amount" :key="item">
                            <input type="number"  @paste="handlePaste" title="code" v-focus="(item - 1) === currentIndex" maxlength="1" max="1" @input="handleInput($event,(item-1))" @keyup.delete="onDelete($event,(item-1))"  v-model="code[item-1]">
                        </div>
                    </div>
                    <Button  shape="circle" long v-if="code.join('').length !== 4 && codeTime !== 0"  disabled style="background-color: rgb(247,247,247)">验证码已发送请注意查收 {{codeTime}}S</Button>
                    <Button type="primary" shape="circle" long v-if="code.join('').length !== 4 && codeTime === 0" @click="sendAgain">重新发送验证码</Button>
                    <Button type="primary" shape="circle" long v-if="code.join('').length === 4" @click="checkCode">确认</Button>

                </div>
            </swiper-slide>
            <swiper-slide>
                <div class="progress">
                    <div class="layout">
                        <span class="title">答题进展</span>
                        <span class="time">计时 {{formatSeconds}}</span>
                    </div>
                    <div class="layout">
                        <Progress :percent="(finished/questions.length).toFixed(2)*100" hide-info :stroke-width="6" stroke-color="#29A77F"/>
                        <p class="num"> <span>{{finished}}</span>/{{questions.length}}</p>
                    </div>
                </div>
                <swiper :options="swiperOptionIn" ref="swiperIn">
                    <swiper-slide v-for="(item,i) in questions" :key="i">
                        <div class="question">
                            <p class="stem">{{i+1}}. {{item.title}}</p>
                            <div class="options" v-if="item.q_type === 1">
                                <Input placeholder="请输入" v-model="userSelect[i].option"/>
                            </div>
                            <ul class="options" v-else>
                                <li class="option" v-for="(option, p) in item.options" :key="'option'+p" :class="{active: userSelect[i].option == option.option}"  @click="$set(userSelect , i,{option:option.option,score:option.score})">
                                    <p>{{option.option}}</p>
                                    <Icon type="ios-checkmark-circle" size="20" color="#fff" v-if="userSelect[i].option == option.option" />
                                    <div class="circle" v-else></div>
                                </li>
                            </ul>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="sign-fail" v-if="!errorMsg">
                            <Icon type="ios-checkmark-circle" size="60" color="#FA6A6A" class="icon"/>
                            <p class="mesg">确认提交?</p>
                            <Button type="primary" shape="circle" @click="sub" v-points>提交</Button>
                        </div>
                    </swiper-slide>
                </swiper>
            </swiper-slide>
            <swiper-slide>
                <div class="success">
                    <Icon type="ios-checkmark-circle" size="60" color="#29A77F" class="icon"/>
                    <p class="mesg">{{info.show_text}}</p>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import 'swiper/dist/css/swiper.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import { Debounce } from '@/tools'
    export default {
        components: {
            swiper,
            swiperSlide
        },
        data () {
            return {
                codeTime: 60,
                amount: 4,
                errorMsg: false,
                send: false,
                info: {
                    name: '',
                    id: '',
                    time: 20,
                    show_text: '感谢你参与本次测评'
                },
                second: 120,
                mobile: '',
                questions: [],
                userSelect: [],
                code: [],
                currentIndex: 0,
                swiperOptionOut: {
                    allowTouchMove: false
                },
                swiperOptionIn: {
                    allowTouchMove: true,
                    preventClicks: false,
                    preventClicksPropagation: false,
                },
            }
        },
        directives: {
            focus: {
                componentUpdated: function (el, obj) {
                    obj.value && el.focus()
                }
            }
        },
        methods: {
            getData() {
                this.$axios.get(this.api.getEvalInfo + '/' + this.$route.params.id).then(res=>{
                    if(res.code){
                        this.info = res.data
                    }else {
                        this.errorMsg = res.msg
                    }
                })
            },
            handleInput (e, index) {
                this.currentIndex = index
                e.target.value = this.validateNumber(e.target.value)
                e.target.value !== '' && ++this.currentIndex
                const code = this.code
                if(code.join('').split('').length >= 4){
                    this.code = code.join('').split('').slice(0,4)
                    this.currentIndex = 3
                }else{
                    this.code = code

                }
            },
            onDelete (e, index) {
                if (e.target.value === '') {
                    this.currentIndex = index - 1
                }
            },
            validateNumber (val) {
                return val.replace(/\D/g, '')
            },
            handlePaste (e) {
                e.preventDefault()
            },
            check() {
                this.$axios.post(this.api.evalCheck,{
                    evaluation_id: this.$route.params.id,
                    mobile: this.mobile,
                }).then( res =>{
                    if( res.code === 1 ){
                        this.$Message.success(res.msg)
                        this.$refs.swiperOut.swiper.slideNext()
                        this.send = true
                        let v =  setInterval(()=>{
                            if(this.codeTime === 0) return clearInterval(v)
                            this.codeTime --
                        }, 1000)
                    }else if(res.code === -2){
                        this.errorMsg = res.msg
                    }else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            sendAgain() {
                this.$axios.post(this.api.evalCheck,{
                    evaluation_id: this.$route.params.id,
                    mobile: this.mobile,
                }).then( res =>{
                    if( res.code === 1 ){
                        this.$Message.success(res.msg)
                        this.send = true
                        this.code = new Array(this.amount).fill('')
                        this.currentIndex = 0
                        let v =  setInterval(()=>{
                            if(this.codeTime === 0) return clearInterval(v)
                            this.codeTime --
                        }, 1000)
                    }else if(res.code === -2){
                        this.errorMsg = res.msg
                    }else {
                        this.$Message.warning(res.msg)
                    }
                })
            },
            checkCode(){
                this.$axios.post(this.api.evalCheckCode,{
                    evaluation_id: this.$route.params.id,
                    mobile: this.mobile,
                    code: this.code.join('')
                }).then(res=>{
                    if( res.code === -2) {
                        this.errorMsg = res.msg
                    }else if( res.code === 0){
                        this.$Message.error(res.msg)
                    }else if( res.code === -3){
                        this.$Message.error(res.msg)
                        this.code = new Array(this.amount).fill('')
                    }else{
                        this.questions = res.data
                        this.questions.forEach( () =>{
                            this.userSelect.push({option: '', score: ''})
                        })
                        this.$refs.swiperOut.swiper.slideNext()
                        this.setTime()

                    }
                })
            },
            setTime() {
                this.second = this.info.time * 60
                let st = setInterval(() => {
                    this.second--
                    if (this.second === 0) {
                        clearInterval(st)
                        this.sub()
                    }
                },1000)
            },
            sub() {
                this.$axios.post(this.api.evalSub,{
                    evaluation_id: this.$route.params.id,
                    mobile: this.mobile,
                    answer: this.userSelect
                }).then(res=>{
                    if( res.code === -2) {
                        this.errorMsg = res.msg
                    }else if( res.code === 0){
                        this.$Message.error(res.msg)
                    }else{
                        this.$refs.swiperOut.swiper.slideNext()
                    }
                })
            }
        },
        computed: {
            finished () {
                let num = 0
                this.userSelect.forEach(item => {
                    if (item.option !== '') {
                        num++
                    }
                })
                return num
            },
            formatSeconds () {
                let secondTime = parseInt(this.second);// 秒
                let minuteTime = 0;// 分
                let hourTime = 0;// 小时
                if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
                    //获取分钟，除以60取整数，得到整数分钟
                    minuteTime = parseInt(secondTime / 60);
                    //获取秒数，秒数取佘，得到整数秒数
                    secondTime = parseInt(secondTime % 60);
                    //如果分钟大于60，将分钟转换成小时
                    if (minuteTime > 60) {
                        //获取小时，获取分钟除以60，得到整数小时
                        hourTime = parseInt(minuteTime / 60);
                        //获取小时后取佘的分，获取分钟除以60取佘的分
                        minuteTime = parseInt(minuteTime % 60);
                    }
                }
                let result = parseInt(secondTime) > 9 ? '' + parseInt(secondTime) : '0' + parseInt(secondTime);

                if (minuteTime > 0) {
                    result = (parseInt(minuteTime) > 9 ? '' + parseInt(minuteTime) : '0' + parseInt(minuteTime)) + ":" + result;
                }
                if (hourTime > 0) {
                    result = (parseInt(hourTime) > 9 ? '' + parseInt(hourTime) : '0' + parseInt(hourTime)) + ":" + result;
                }
                return result;
            }
        },

        created () {
            this.code = new Array(this.amount).fill('')
            this.getData()
        },
    }
</script>

<style lang="less" scoped>
.box{
    width: 500px;
    margin: 30px auto;
    min-height: ~'calc(100vh - 120px)';
    .login{
        padding: 10px 50px;
        background: url(../../images/evalbg.png) 0 0 no-repeat;
        background-size: cover;
        .title{
            font-size: 26px;
            color: #000000;
            font-weight: bold;
            padding: 30px 0 10px 0;
        }
        .msg{
            color: #75787F;
            font-size: 14px;
            margin-bottom: 30px;
        }
        .ivu-btn{
            background-color: #29A77F;
            padding: 10px 0;
            margin-top: 15px;
        }
        /deep/.ivu-input{
            height: 40px;
            padding: 8px 15px;
            background-color: #F7F7F7;
            border: none;
            border-radius: 25px;
            margin: 10px 0;

        }
    }
    .question{
        padding: 0 30px;
        .stem{
            color: #1a1a1a;
            font-size: 18px;
            font-weight: bold;
        }
        .options{
            padding: 22px 0;
            .option{
                color: #75787F;
                font-size: 14px;
                background-color: #f7f7f7;
                padding: 15px 20px 15px 25px;
                margin-bottom: 20px;
                border-radius: 50px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .circle{
                    width: 17px;
                    height: 17px;
                    border-radius: 50%;
                    border: 1px solid #E6E8ED;
                }
            }
            .active{
                color: #fff;
                background-color: #29A77F;
            }
        }
    }
    .progress{
        padding: 2px 30px 20px 30px;
        .layout{
            padding: 2px 0;
            display: flex;
            justify-content: space-between;
        }
        .title{
            color: #1a1a1a;
            font-size: 13px;
        }
        .time{
            color: #75787F;
            font-size: 13px;
        }
        .num{
            color: #BFC1C6;
            margin-left: 10px;
            span{
               color: #29A77F;
            }
        }
    }
    .code-box{
        padding: 10px 50px;
        .title{
            font-size: 26px;
            color: #000000;
            font-weight: bold;
            padding: 30px 0;
        }
        .ivu-btn{
            background-color: #29A77F;
            padding: 10px 0;
            margin-top: 15px;
        }
        .ys-verification{
            margin: 30px 0 20px 0;
            display: flex;
            justify-content: space-around;
            .input-wrapper{
                width: 20%;
                height: 0;
                padding-bottom: 20%;
                input{
                    width: 60px;
                    height: 60px;
                    text-align: center;
                    transition: all 0.3s;
                    font-size: 7vw;
                    color: #262626;
                    border: 1px solid #E6E8ED;
                    border-radius: 10px;
                }
            }
            input:focus{
                border: 1px solid #29A77F;
            }
        }
    }
    .success{
        text-align: center;
        .icon{
            margin: 50px 0 20px 0;
        }
        .mesg{
            color: #1A1A1A;
            font-size: 28px;
            font-weight: bold;
        }
    }
    .sign-fail{
        text-align: center;
        .icon{
            margin: 50px 0 20px 0;
        }
        .mesg{
            color: #1A1A1A;
            font-size: 28px;
            font-weight: bold;
        }
        .num{
            color: #BABDC3;
            line-height: 30px;
            font-size: 14px;
        }
        .ivu-btn{
            background-color: #29A77F;
            padding: 10px 50px;
            margin-top: 30px;
        }
    }
}
</style>
